
import React, { useEffect, useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { RadioInput, TextInput } from '../../../../Helpers/Inputs';
import TobaccoUsage from '../../Helpers/TobaccoUsage';
import BusinessHours from '../BusinessHours';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../../sessionStorage';
import CircularProgress from '@material-ui/core/CircularProgress';
import Scheduler from '../Scheduler';
import { saveSessionEvent } from '../../../../../session';
import BackNext from '../../SubComponents/BackNext';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { emptyStringToUndefined } from '../../../../Helpers/Formatters/EmptyStringToUndefined.js';
import '../Appointment.scss';
import PropTypes from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';
import SvgIcon from "@material-ui/core/SvgIcon";
import { InputMaskPhone } from '../../../../Helpers/Formatters';
import { object, string } from '../../../../Helpers/Validators/customValidators'
import { makeStyles } from "@material-ui/core/styles";
import { parseHealthData, parseHealthHiddenData } from '../../Helpers/ParseHealth';

const useStyles = makeStyles(theme => ({
  colorText: {
    color: theme.palette.primary.main
  }
}));

export default function ScheduleAppointment(props) {
  const classes = useStyles();

  var phone = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.phone;

  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: ScheduleAppointment.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  // manually call setValue for fields that don't play nice with react-hook-form register
  const handleValueChange = (field, value) => {
    if (field === 'specificApptDate') {
      let fullForm = { ...props.fullFormState }
      fullForm.pages.appointment.specificApptDate = value;
      fullForm.pages.appointment.specificApptTime = '';
      props.onMultiFieldChange(fullForm);
      setValue('specificApptTime', '');
    }
    else {
      props.onFieldChange(field, value);
    }
    setValue(field, value);
  };

  useEffect(() => {
    if (props.formState.timeZone == '') {
      props.handleTimeZone("Eastern");
    }
  })

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register  
    register({ name: 'specificAppt' });
    setValue('specificAppt', props.formState.specificAppt);

    register({ name: 'phoneNumber' });
    setValue('phoneNumber', props.formState.phoneNumber);

    register({ name: 'timeZone' });
    setValue('timeZone', props.formState.timeZone);

    register({ name: 'specificApptDate' });
    setValue('specificApptDate', props.formState.specificApptDate);

    register({ name: 'specificApptTime' });
    setValue('specificApptTime', props.formState.specificApptTime);
  }, [register]);

  const [postingApp, setPosting] = useState(false);

  const calculateTotalHeight = (height) => {
    const radix = 10;
    var heightArray = height.split(' ');
    var heightFeet = parseInt(heightArray[0], radix);
    var heightInches;
    for (var i = 1; i < heightArray.length; i++) {
      if (heightArray[i] !== '' && heightArray[i] !== 'ft') {
        heightInches = parseInt(heightArray[i], radix);
        break;
      }
    }
    return heightFeet + ' ' + heightInches;
  }

  const basicInfoTobacco = TobaccoUsage(props.basicInfo.tobacco)
  const tobaccoStatus = (basicInfoTobacco === "yes" || basicInfoTobacco === "no") ? basicInfoTobacco : (basicInfoTobacco === "true" ? "yes" : "no");
  const isLeadData = props.fullFormState && props.fullFormState.pages.myHealthProfile && props.fullFormState.pages.background;

  const postApp = () => {
    setPosting(true);
    var body = {
      'consumerAccountId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId,
      'oneClickAccountId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.oneClickAccountId,
      'dob': props.basicInfo.birthdate,
      'firstname': props.formState.firstName || props.basicInfo.firstName,
      'lastname': props.formState.lastName || props.basicInfo.lastName,
      'gender': props.basicInfo.gender,
      'usCitizen': props.basicInfo.usResident,
      'weight': props.basicInfo.weight ? props.basicInfo.weight.split(" ")[0] : '',
      'height': props.basicInfo.height ? calculateTotalHeight(props.basicInfo.height) : '',
      'healthclass': props.quoter.healthClass,
      'state': props.basicInfo.state,
      'zipCode': props.basicInfo.zipCode || 0,
      'phone': props.formState.phoneNumber,
      'face': props.quoter.coverageAmount,
      'tobacco': TobaccoUsage(tobaccoStatus) === 'yes',
      'email': props.basicInfo.email || props.formState.email,
      'term': parseInt(props.quoter.term, 10),
      'carrier': props.quoter.carrierName,
      'product': props.quoter.product,
      'quotedpremium': props.quoter.premium,
      'quotedpremiummode': 'M',
      'specialNote': props.quoter.specialNote || '',
      'timeZone': props.formState.timeZone,
      'specificappointmentutc': props.formState.specificAppt === 'schedule' ? props.formState.specificApptTime : null,
      'leadCustomData': isLeadData ? parseHealthData(props.fullFormState) : {},
      'leadCustomHiddenData': isLeadData ? parseHealthHiddenData(props.fullFormState) : {}, 
    }
    fetch(`api/Case/PostApp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(body),
    })
      .then(response => response.json())
      .then((data) => {
        if (data.success) {
          saveSessionEvent(true);
          props.onNext()
        }
        else {
          setPosting(false);
        }
      }).catch((error) => {
        setPosting(false);
      })
  }
  const setContactDetails = () => {
    const start = 8 * 60;
    const end = 19 * 60 + 30;

    let date = new Date();

    let usaTime = date.toLocaleTimeString('en-US', {
      timeZone: "America/New_York",
      hour12: false
    });

    let arr = usaTime.split(':')

    const now = Number(arr[0]) * 60 + Number(arr[1]);
    if (start <= now && now <= end) {
      return (
        <div>
          <h4 className={`${classes.colorText} mt-4 text-center hide-class`} >{phone}</h4>
          <a href={`tel:+ ${phone}`} className='display-class'>
            <h4 className={`${classes.colorText} mt-4 text-center`} >{phone}</h4> </a>
          <h6 className='mt-0 mb-5 text-center'>Feel free to contact us directly.</h6>
        </div>
      )
    }
    else return null

  }

  return (
    <Col xs={12} md={6} lg={4}>
      <Form onSubmit={handleSubmit(postApp)} className='mt-2'>
        {
          props.isAppointmentSchedulingEnabled === false ? <div className="mt-4 mb-4">{props.isDropTicket ? 'One of our insurance experts will reach out to you to help start your coverage. It only takes a few minutes.' : 'One of our insurance experts will be in contact with you shortly'}</div> : (
            <React.Fragment>
              <Row className="justify-content-center">
                <SvgIcon component={CheckIcon} className="icons" color="primary" fontSize="large" />
              </Row>
              <h4 className="text-center pt-2"><b>{props.isDropTicket ? 'Your Next Step' : `Hi, ${props.basicInfo.firstName}`}</b></h4>
              <div className='text-center sizeOfheaders mt-3  mb-0'>We need to verify some personal information.</div>
              <div className='text-center sizeOfheaders mb-0'>One of our licenced specialists will contact you.</div>
              <div className='text-center sizeOfheaders'>It will only take a few minutes!</div>
              <Form.Group className='mb-0 ml-0'>
                <RadioInput
                  name="specificAppt"
                  id="specificAppt"
                  label=""
                  value={props.formState.specificAppt}
                  radios={[{ value: "asap", label: "Contact me within one business day" }]}
                  onChange={e => handleValueChange('specificAppt', e.target.value)}
                  errors={errors.specificAppt}
                  inputRef={register}
                />
              </Form.Group>
              {props.formState.specificAppt === 'asap' &&
                <Form.Group>
                  <TextInput
                    name="phoneNumber"
                    id="phoneNumber"
                    label="Preferred Phone #"
                    value={props.formState.phoneNumber}
                    onChange={(e) => handleValueChange('phoneNumber', e.target.value)}
                    errors={errors.phoneNumber}
                    inputRef={register}
                    InputProps={{
                      inputComponent: InputMaskPhone,
                    }}
                  />
                  <div className='mt-1 pt-0 italicText'>Your phone # will only be used to complete your application</div>
                </Form.Group>
              }
              <Form.Group>
                <RadioInput
                  name="specificAppt"
                  id="specificAppt"
                  label=""
                  value={props.formState.specificAppt}
                  radios={[{ value: "schedule", label: 'Select date/time for phone call' }]}
                  onChange={e => handleValueChange('specificAppt', e.target.value)}
                  errors={errors.specificAppt}
                  inputRef={register}
                />
              </Form.Group>

              {props.formState.specificAppt === 'schedule' &&
                <Form.Group>
                  <TextInput
                    name="phoneNumber"
                    id="phoneNumber"
                    label="Preferred Phone #"
                    value={props.formState.phoneNumber}
                    onChange={(e) => handleValueChange('phoneNumber', e.target.value)}
                    errors={errors.phoneNumber}
                    inputRef={register}
                    InputProps={{
                      inputComponent: InputMaskPhone,
                    }}
                  />
                </Form.Group>
              }
              <Scheduler
                hide={props.formState.specificAppt !== 'schedule'}
                hideBusinessHours={true}
                register={register}
                errors={errors}
                timeZone={props.formState.timeZone}
                apptDate={props.formState.specificApptDate}
                apptTime={props.formState.specificApptTime}
                setTimeZone={(e) => handleValueChange('timeZone', e)}
                setApptDate={(e) => handleValueChange('specificApptDate', e)}
                setApptTime={(e) => handleValueChange('specificApptTime', e)}
              />
              {props.formState.specificAppt === 'schedule' && <div className='mt-1 pt-0 mb-5 italicText'>Your phone # will only be used to complete your application</div>}
              {
                setContactDetails()
              }
            </React.Fragment>

          )
        }

        {postingApp ? (
          <div className="submit-loading-container">
            <CircularProgress />
          </div>
        ) : (
          <BackNext onBack={props.onBack} continueLabel={{ text: 'Submit' }} />
        )}

        <BusinessHours />

        <p className="disclaimer">By clicking Submit, you are providing your signed permission for Covr Financial Technologies to contact you at the email and telephone number provided, including via text message and live, automated and pre-recorded telephone calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time by emailing us at <a href="mailto:support@covrtech.com">support@covrtech.com</a>.</p>
      </Form>
    </Col>

  )
}

ScheduleAppointment.ValidationSchema = object().shape({
  specificAppt: string().when('showAppointmentInputs', {
    is: true,
    then: string().oneOf(['schedule', 'asap'], 'You must select an appointment type.'),
    otherwise: string().notRequired()
  }),
  timeZone: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: string().required("Timezone is required."),
  }),
  specificApptDate: string().transform(emptyStringToUndefined).when('specificAppt', {
    is: 'schedule',
    then: string().required("Date is required."),
  }),
  specificApptTime: string()
    .when('specificAppt', {
      is: 'schedule',
      then: string().required('Time of call is required.'),
      otherwise: string().notRequired()
    }),
  phoneNumber: string()
    .required('Phone Number is required.')
    .isValidPhone('Phone Number must be formatted as "(123) 456-7890".'),

});

ScheduleAppointment.DefaultFormState = (prefill = false, basicInfo = null) => {
  return null;
};

ScheduleAppointment.propTypes = {
  formState: PropTypes.object.isRequired,
  quoter: PropTypes.object.isRequired,
  basicInfo: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  isAppointmentSchedulingEnabled: PropTypes.bool.isRequired,
  fullFormState: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/AppointmentSteps/ScheduleAppointment.js